import { render, staticRenderFns } from "./clientInput.vue?vue&type=template&id=c04553d6&"
import script from "./clientInput.vue?vue&type=script&lang=js&"
export * from "./clientInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports